<template>
    <div class="bindGZH">
        <div class="bindGZH_navBar">
            <div class="bindGZH_title">绑定账号</div>
        </div>
        <div class="bindGZH_form">
            <div class="inputPhone">
                <div class="label">+86</div>
                <div class="line">|</div>
                <input ref="moblie" v-model="moblieValue" type="text" placeholder="请输入手机号" maxlength="11"
                       @blur="checkMoblie()" />
            </div>
            <div class="inputCode">
                <input type="password" v-model="code" placeholder="请输入密码" />
            </div>
            <div class="selectCity">
                <span>所在城市：</span>
                <van-radio-group v-model="city" class="cityRadioGroup">
                    <van-radio name="1" icon-size="16px">大连/沈阳</van-radio>
                    <van-radio name="2" icon-size="16px">烟台</van-radio>
                    <van-radio name="3" icon-size="16px">深圳</van-radio>
                </van-radio-group>
            </div>

            <div class="btnDiv">
                <button class="loginBtn" type="submit" @click="login">登录</button>
            </div>

            <div class="point">
                温馨提示：请确认所填账号、密码、地址无误，否则将影响消息接收
            </div>
        </div>

        <loading v-if="loadingFlag"></loading>

    </div>
</template>

<script>
    import {responseUtil} from "../../libs/rongxunUtil";
    import {Popup, Notify, Overlay,RadioGroup, Radio} from "vant";
    import loading from '../../components/rongxun/rx-loading/loading'
    import {token,yttoken,sztoken} from "../../getData/getData";

    export default {
        name: "bindGZH",
        components: {
            loading,
            [RadioGroup .name]:RadioGroup,
            [Radio .name]:Radio,
        },
        data() {
            return {
                loadingFlag:false,

                code: '',
                moblieValue: "", //手机输入框状态
                city:'1',

            }
        },
        mounted() {
            console.log(this.$route.query)
        },
        methods:{
            login() {
                if (this.moblieValue === undefined || this.moblieValue === '') {
                    // uni.showToast({
                    //     icon: "none",
                    //     title: '请先输入手机号和密码',
                    // });
                    Notify({ type: "warning", message: "请先输入手机号和密码" });
                    return
                }
                let that = this
                let userName = `{"type":"front","userName": ${that.moblieValue}}`
                let params = {
                    username: userName,
                    password: that.code,
                    grant_type: 'password',
                    scope: 'all'
                }
                let func
                if(this.city==='1'){  //海寓
                    func = token
                }else if(this.city==='2'){  //烟台
                    func = yttoken
                }else if(this.city==='3'){  //深圳
                    func = sztoken
                }
                func(params).then(function(response) {
                    if (response.data.access_token) {
                        // console.log(response.data);
                        // that.cokiesAndSkip(response.data, that);
                        // that.getVersion();
                        // that.saveCid();
                    }
                }).catch(function() {
                    responseUtil.alertMsg(that, '用户名或密码错误')
                })
            },
            checkMoblie() {
                let re = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
                let phone = this.moblieValue;
                if (phone!=='' && phone!==undefined && !re.test(phone)) {
                    responseUtil.alertMsg(this, '手机格式有误')
                }
            },
        }
    }
</script>

<style scoped>
    .bindGZH{
        background-color: white;
        height: 100vh;
        width: 100vw;
        overflow: auto;
    }

    .bindGZH_navBar{
        width: 100vw;
        height: 1.3rem;
        position: fixed;
        top: 0px;
        background-color: #f8f8f8;
        font-weight: bold;
        font-size: 0.48rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bindGZH_title{
        width: auto;
    }

    .bindGZH_form{
         margin-top: 2rem;
    }

    /*手机号码输入框DIV*/
    .inputPhone {
        height: 34px;
        background: #fff;
        width: 82%;
        margin: 10px auto;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: center;
    }

    /* +86 */
    .label {
        color: #3a80bf;
        font-size: 16px;
        margin-left: 11px;
    }

    /*竖线样式*/
    .line {
        padding-right: 5.5px;
        padding-left: 5.5px;
        color: #d8d8d8;
        font-size: 15px;
    }

    /*手机号码输入框*/
    .inputPhone input {
        flex: 1 1 auto;
        border: none;
        font-size: 16px;
        background: #fff;
    }

    /*验证码输入框Div*/
    .inputCode {
        background: #fff;
        width: 82%;
        margin: 15px auto 10px;
        border-bottom: 1px solid #efefef;
        display: flex;
        align-items: flex-end;
    }

    /*验证码输入框*/
    .inputCode input {
        border: none;
        vertical-align: middle;
        font-size: 16px;
        background: #fff;
        margin-left: 11px;
        flex: 1 1 auto;
        margin-bottom: 7px;
    }

    .selectCity{
        width: calc(82vw - 22px);
        margin: 15px auto 10px;
        font-size: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .cityRadioGroup{
        margin-top: 2px;
        margin-left: 5px;
    }
    .cityRadioGroup div{
        margin-bottom: 5px;
    }

    .btnDiv {
        margin: 56px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loginBtn {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        padding: 6px;
        color: white;
        width: 90%;
        border: 0;
        border-radius: 5px;
        /*圆角*/
        background: linear-gradient(to right, #a2c0db, #3a80bf);
        /*渐变色*/
    }

    /*温馨提示样式*/
    .point {
        margin: 37.5px auto 0;
        padding-top: 7.5px;
        padding-bottom: 7.5px;
        width: 90%;
        font-size: 12px;
        color: red;
        line-height: 20px;
    }
</style>